const environment = "test";

export const hourlyMain = (
  <div>
    Hourly APIs are the set of APIs that allows you to book transfers based on
    hourly basis.
    <br />
    <br />
    This API allows you to obtain a Search ID based on the provided booking
    details (placename,latitude and longitude for source, travelldate, travell
    time, hour, number of passenger) and passenger Details (firstname, lastname,
    email, phone, country, dialcode, flightOrTrain, reference, specialRequest).
    <br />
    <br />
    This Search ID can then be used to retrieve vehicle options and pricing.
    <br />
    <br />
    To retrieve the geocodes for pickup location, you can use the following API
    provided by our end:
    <br />
    Geocodes for Pickup API: Use this API to find geocodes for the specified
    pickup location.
    <br />
    <br />
    Alternatively, you may provide the placename along with the geocodes
    directly.
  </div>
);

export const hourlysearchIdDatas = {
  intro: `This API provides search Id for hourly transfers`,

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/searchIdGenerateHourly?email=email`
      : `https://api.drivado.com/api/v1/api/searchIdGenerateHourly?email=email`,

  responseDes: `Upon a successful response, a Search ID will be generated. This Search ID can then be used to retrieve the vehicle's price and proceed with booking the vehicle.`,
};

export const hourlyVehiclePricesDatas = {
  intro: (
    <div>
      This API accepts the search Id and email as query parameters and returns
      all available vehicles along with their prices.
    </div>
  ),

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/vehiclesWithPriceHourly?searchId=searchId&email=email`
      : `https://api.drivado.com/api/v1/api/vehiclesWithPriceHourly?searchId=searchId&email=email`,

  responseDes: `Upon a successful response,the vehicles with their respective prices and other details will be generated. This Search ID and the vehicle Id can then be used for booking the transfer`,
};

export const hourlyBookingWithVehicleDatas = {
  intro: (
    <div>
      This API accepts the searchId and email as query parameters and the
      vehicleId as a body parameter. The vehicleId is obtained from the "Price
      with Vehicle" API and is used to book hourly transfers.
    </div>
  ),

  endpoint:
    environment === "test"
      ? `https://testapi.drivado.com/api/v1/api/bookHr?searchId=searchId&email=email`
      : `https://api.drivado.com/api/v1/api/bookHr?searchId=searchId&email=email`,

  responseDes: `Booking will be created successfully`,
};
